import React from 'react'
import Link from 'next/link'
import { domParser, nodeParser, Parser } from '.'
import { type DOMNode, attributesToProps, domToReact } from 'html-react-parser'
import { log } from '@dustin-web/microsite-config/src/logger'
const prefixesToRewrite = ['www.dustin.']

// const LOCALIZED_SEARCH_ROUTES = ['/sok/', '/sog/', '/hae/', '/zoeken/', '/search/']
// const linksToExclude = [
//   '/group/',
//   '/brands/',
//   '/product/',
//   '/theme/better',
//   '/solutions/takeback',
//   '/solutions/detect-och-response',
//   '/solutions/managed-print',
//   '/solutions/storage',
//   '/solutions/network',
//   '/solutions/paketerade-tjanster',
//   '/contact',
//   '/registration',
//   ...LOCALIZED_SEARCH_ROUTES,
// ]

export const linkParser: Parser = (node, additionalMacros, additionalNodeParsers) => {
  // eslint-disable-next-line no-prototype-builtins
  if (node.type === 'tag' && node.attribs.hasOwnProperty('href')) {
    const target = node.attribs.target
    if (target && target !== '_self') {
      return
    }

    let href = node.attribs.href as string | undefined
    href = href?.trim()

    const props = attributesToProps(node.attribs)

    if (href?.startsWith('#')) {
      return (
        <a {...attributesToProps(node.attribs)}>
          {domToReact(node.children, { replace: (child: DOMNode) => nodeParser(child) })}
        </a>
      )
    }

    if (href && prefixesToRewrite.some(prefix => href && href.includes(prefix))) {
      if (!href.startsWith('http')) {
        href = 'https:' + href
      }

      let newHref = href

      try {
        const url = new URL(href)
        newHref = url.pathname.replace(/\/$/, '/') + url.search
        // if (linksToExclude.some(link => url.pathname.includes(link))) {
        node.attribs.href = newHref
        return node
        // }
      } catch {
        log.warn(`Invalid URL format found on href on <a> tag on a content page. Href was: ${href}`)
      }

      return (
        <Link prefetch={false} {...props} href={newHref} shallow scroll>
          {domParser(node.children, additionalMacros, additionalNodeParsers)}
        </Link>
      )
    }
  }
}
